import { fetchRequestAsync, updateCommunityRequestTagsAsync } from '../actions/request';
import { buildFlagReducer } from '../store/utils';

export const fetchRequestFlag = buildFlagReducer(fetchRequestAsync);

export const updateRequestFlag = buildFlagReducer(updateCommunityRequestTagsAsync);
